import styled from "styled-components";

export const UploadStyled = styled.div`
  .label {
    margin-bottom: 4px;
    color: ${({ theme }) => theme.COLORS.BLACK_1};
    font-size: ${({ theme }) => theme.FONT.SIZE.S14};
    font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_REGULAR};
  }
  .dropzone {
    cursor: pointer;
    .input_upload_container {
      border-radius: 21px;
      border: 0.5px solid ${({ theme }) => theme.COLORS.PUEPLE_1};
      padding: 0 24px;
      height: 40px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      color: ${({ theme }) => theme.COLORS.PURPLE_1};
      font-size: ${({ theme }) => theme.FONT.SIZE.S14};
      font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_REGULAR};
    }
  }
  .uploaded_files {
    margin-bottom: 8px;
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    .file_item {
      .file_container {
        position: relative;
        display: inline-block;
      }
      .file_img {
        border-radius: 4px;
        width: 100px;
        height: 100px;
        object-fit: cover;
      }
      .file_placeholder {
        border-radius: 4px;
        width: 100px;
        height: 100px;
        background-color: #f5f5f5;
        border: 2px dashed #ccc;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #999;
      }
      .progress_overlay {
        position: absolute;
        top: 0;
        left: 0;
        width: 100px;
        height: 100px;
        background-color: rgba(0, 0, 0, 0.7);
        border-radius: 4px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .circular_progress {
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .progress_ring {
        transform: rotate(-90deg);
      }
      .progress_ring_circle {
        transition: stroke-dashoffset 0.3s ease;
      }
      .progress_text {
        position: absolute;
        color: white;
        font-size: 12px;
        font-weight: bold;
        text-align: center;
      }
      .remove_btn {
        position: absolute;
        top: -8px;
        right: -8px;
        border-radius: 50%;
        border: 1px solid ${({ theme }) => theme.COLORS.RED_1};
        width: 20px;
        height: 20px;
        background: ${({ theme }) => theme.COLORS.WHITE_1};
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        z-index: 10;

        &:hover {
          transform: scale(1.1);
        }

        svg {
          color: white;
        }
      }
    }
  }
  .upload_reccomment {
    margin-top: 4px;
    margin-left: 4px;
    color: ${({ theme }) => theme.COLORS.PURPLE_1};
    font-size: ${({ theme }) => theme.FONT.SIZE.S12};
    font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_LIGHT};
  }
  .errors {
    margin-top: 2px;
    font-size: ${({ theme }) => theme.FONT.SIZE.S12};
    color: ${({ theme }) => theme.COLORS.RED_1};
  }

  .theme_standard {
  }
`;
